var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-view d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"container"},[_c('CheckoutFlow',{staticClass:"shadow-lg"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }